import ListIcon from '@mui/icons-material/List'
import { Paper } from '@mui/material'
import { CustomTable, FormHeader } from 'components'
import { ITableHeadCellDTO } from 'data/dtos/components/i-table-head-cell-dto'
import { IUserGroupDTO } from 'data/dtos/security/i-user-group-dto'
import React, { useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadCellDTO[] = [
  {
    id: 'name',
    label: 'Nome',
    width: 11,
  },
]

const UserGroupList: React.FC = () => {
  const [loading, setLoading] = useState(0)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100)
  const [orderByDirection, setOrderByDirection] = useState(true)
  const [rowsCount, setRowsCount] = useState(0)
  const [userGroupsList, setUserGroupsList] = useState<IUserGroupDTO[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadUserGroups = async () => {
    setLoading(1)

    await api
      .post('/user-groups/list', { search, page, rowsPerPage, columnOrder })
      .then(async (listResponse) => {
        const { data } = listResponse.data
        setUserGroupsList(data)

        await api
          .post('/user-groups/count', { search })
          .then((countResponse) => {
            const { count } = countResponse.data.data
            setRowsCount(count)
          })
          .then(() => setLoading(0))
          .catch((error) => {
            console.log(error)
          })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleDelete = async () => {
    await api
      .delete(`/user-groups/${recordToDelete}`)
      .then(async () => {
        await loadUserGroups()
      })
      .catch((error) => {
        console.log(error.response?.data)
      })
  }

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadUserGroups()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadUserGroups()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Paper
      elevation={3}
      className={classes.paper}
    >
      <FormHeader
        title='Grupos de Usuários'
        icon={ListIcon}
        newRoute='/user-groups/new'
        helpText='Nesta opção serão informados os grupos de usuários da aplicação.'
      />

      <CustomTable
        headCells={headCells}
        rows={userGroupsList}
        totalRows={rowsCount}
        handleSearch={setSearch}
        isLoading={loading}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        page={page}
        editRoute='/user-groups/edit'
        handleDelete={handleDelete}
        handleRecordToDelete={setRecordToDelete}
        columnOrder={columnOrder}
        setColumnOrder={setColumnOrder}
        orderByDirection={orderByDirection}
        setOrderByDirection={setOrderByDirection}
      />
    </Paper>
  )
}

export default UserGroupList
